/**
 * Tool Execution Hooks
 */

import { useQuery } from '@tanstack/react-query';
import {
  getToolExecutions,
  getToolExecutionsByTool,
  getToolExecutionStats,
} from '../features/api/toolExecutions';

export function useToolExecutions(page = 0, size = 20) {
  const query = useQuery({
    queryKey: ['toolExecutions', page, size],
    queryFn: () => getToolExecutions(page, size),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useToolExecutionsByTool(toolId: string, page = 0, size = 20) {
  const query = useQuery({
    queryKey: ['toolExecutions', toolId, page, size],
    queryFn: () => getToolExecutionsByTool(toolId, page, size),
    enabled: !!toolId,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useToolExecutionStats(period?: string) {
  const query = useQuery({
    queryKey: ['toolExecutionStats', period],
    queryFn: () => getToolExecutionStats(period),
  });

  return {
    stats: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
